import moment from "moment";
import "moment/locale/uk";
import "moment/locale/ru";
import mainSelect from "@/components/main-select/index.vue";
import { validationMixin } from "vuelidate";
import { email, maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
import { camelCase } from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import auth from "@/store/modules/auth";

export default {
    name: "register-agent",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                firstName: "",
                secondName: "",
                lastName: "",
                position: "",
                email: "",
                phone: "",
                day: "",
                mounth: "",
                year: "",
                password: "",
                password_confirmation: "",
            },
            inputName: "",
            inputLastName: "",
            inputLastPatronymic: "",
            position: "",
            email: "",
            validationErrors: {},
        };
    },
    components: {
        mainSelect,
    },
    validations: {
        payload: {
            day: {
                required,
            },
            year: {
                required,
            },
            mounth: {
                required,
            },
            name: {
                required,
                maxLength: maxLength(50),
            },
            lastName: {
                required,
                maxLength: maxLength(50),
            },
            secondName: {
                required,
                maxLength: maxLength(50),
            },
            phone: {
                required,
                minLength: minLength(19),
            },
            email: {
                required,
                email,
                maxLength: maxLength(50),
            },
            password: {
                required,
                email: "",
                minLength: minLength(8),
                maxLength: maxLength(20),
            },
            password_confirmation: {
                maxLength: maxLength(20),
                required,
                sameAsPassword: sameAs("password"),
            },
            position: {
                required,
                maxLength: maxLength(50),
            },
        },
    },
    computed: {
        ...mapGetters({
            popupRegisterAgent: "auth/popupRegisterAgent",
            popupRegisterAgentThanks: "auth/popupRegisterAgentThanks",
        }),
        birthdayErrors() {
            let error = [];
            if (!this.$v.payload.day.$dirty || !this.$v.payload.mounth.$dirty || !this.$v.payload.year.$dirty) {
                return error;
            }
            if (!this.$v.payload.day.required || !this.$v.payload.mounth.required || !this.$v.payload.year.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.day || this.validationErrors.mounth || this.validationErrors.year) {
                this.validationErrors.day.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        positionErrors() {
            let error = [];
            if (!this.$v.payload.position.$dirty) {
                return error;
            }
            if (!this.$v.payload.position.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.position.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.position) {
                this.validationErrors.position.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        secondNameErrors() {
            let error = [];
            if (!this.$v.payload.secondName.$dirty) {
                return error;
            }
            if (!this.$v.payload.secondName.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.secondName.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.secondName) {
                this.validationErrors.secondName.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        lastNameErrors() {
            let error = [];
            if (!this.$v.payload.lastName.$dirty) {
                return error;
            }
            if (!this.$v.payload.lastName.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.lastName.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.lastName) {
                this.validationErrors.lastName.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordErrors() {
            let error = [];
            if (!this.$v.payload.password.$dirty) {
                return error;
            }
            if (!this.$v.payload.password.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.password.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password.minLength) {
                error.push(this.$t("validationMin").replace(":count", 8));
            }
            if (this.validationErrors.password) {
                this.validationErrors.password.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        passwordConfirmationErrors() {
            let error = [];
            if (!this.$v.payload.password_confirmation.$dirty) {
                return error;
            }
            if (!this.$v.payload.password_confirmation.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.password_confirmation.sameAsPassword) {
                error.push(this.$t("validationSameAs"));
            }
            if (this.validationErrors.password_confirmation) {
                this.validationErrors.password_confirmation.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        acceptAgreementError() {
            let error = [];
            if (!this.$v.payload.consent.$dirty) {
                return error;
            }
            if (!this.$v.payload.consent.sameAs) {
                error.push(this.$t("validateAcceptAgreement"));
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        days() {
            const arr = [];
            for (let i = 1; i < 32; i++) {
                arr.push(i);
            }
            return arr;
        },
        mounth() {
            const locale = window.location.pathname.slice(0, 4);

            return moment.months().map((e, index) => {
                if (locale === "/uk/") {
                    e === "январь" ? (e = "Січень") : null;
                    e === "февраль" ? (e = "Лютий") : null;
                    e === "март" ? (e = "Березень") : null;
                    e === "апрель" ? (e = "Квітень") : null;
                    e === "май" ? (e = "Травень") : null;
                    e === "июнь" ? (e = "Червень") : null;
                    e === "июль" ? (e = "Липень") : null;
                    e === "август" ? (e = "Серпень") : null;
                    e === "сентябрь" ? (e = "Вересень") : null;
                    e === "октябрь" ? (e = "Жовтень") : null;
                    e === "ноябрь" ? (e = "Листопад") : null;
                    e === "декабрь" ? (e = "Грудень") : null;
                }
                return {
                    id: index + 1,
                    name: e,
                };
            });
        },
        years() {
            const arr = [];
            const currentYear = new Date().getFullYear();
            for (let i = currentYear - 90; i < currentYear - 10; i++) {
                arr.unshift(i);
            }
            return arr;
        },
    },
    created() {},
    methods: {
        ...mapActions({
            registrationAgent: `auth/REGISTRATION_AGENT`,
        }),
        ...mapMutations({
            changePopupRegisterAgent: `auth/CHANGE_POPUP_REGISTER_AGENT`,
            changePopupRegisterAgentThanks: `auth/CHANGE_POPUP_REGISTER_AGENT_THANKS`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let registerData = {};
                registerData.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                registerData.password = this.payload.password;
                registerData.password_confirmation = this.payload.password_confirmation;
                registerData.name = this.payload.name;
                registerData.second_name = this.payload.secondName;
                registerData.last_name = this.payload.lastName;
                registerData.birthday = this.payload.year + "-" + this.payload.mounth.id + "-" + this.payload.day;
                registerData.position = this.payload.position;
                registerData.email = this.payload.email;
                // console.log(this.payload.year,this.payload.mounth.id,this.payload.day);
                this.registrationAgent(registerData)
                    .then(() => {
                        this.$toasted.success(this.$t("fillDataAfterRegister"));
                        this.changePopupRegisterAgent(false);
                        this.changePopupRegisterAgentThanks(true);
                        // this.fetchUser().then(() => {
                        //   setTimeout(() => {
                        //     this.changePersonalData(true);
                        //   }, 100)
                        //
                        // })
                        this.$v.$reset();
                    })
                    .catch(error => {
                        console.log(error.response);
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                            const errors = error.response.data.errors;
                            for (const i in errors) {
                                Vue.set(this.validationErrors, camelCase(i), errors[i]);
                                errors[i].forEach(e => {
                                    this.$toasted.error(e);
                                });
                            }
                        } else {
                            console.log(error.response);
                        }
                    });
            }
        },
        // validName(e) {
        //     let char = String.fromCharCode(e.keyCode);
        //     if (/^[a-zA-Zа-яА-я- ]*$/.test(char)) return true;
        //     else e.preventDefault();
        // },
        // validEmail(e) {
        //     let char = String.fromCharCode(e.keyCode);
        //     if (/^[a-zA-Z0-9-а-яА-я-@/.]*$/.test(char)) return true;
        //     else e.preventDefault();
        // },
    },
};
